import { render, staticRenderFns } from "./ShoppingCarDetails.vue?vue&type=template&id=42835df9&scoped=true&"
import script from "./ShoppingCarDetails.vue?vue&type=script&lang=js&"
export * from "./ShoppingCarDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingCarDetails.vue?vue&type=style&index=0&id=42835df9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42835df9",
  null
  
)

export default component.exports